import { B2bColorScheme } from 'shared-types/colorScheme';
import ColormapInterface from 'shared-types/colormapinterface';

import colormapBam from './colormaps/colormapBam';

const colorMap = (colors: B2bColorScheme): ColormapInterface => {
  return colormapBam(colors);
};

export default colorMap;
